import { render } from "./FhaMipPaymentsDashboard.vue?vue&type=template&id=5ac6cbc4&scoped=true"
import script from "./FhaMipPaymentsDashboard.vue?vue&type=script&lang=js"
export * from "./FhaMipPaymentsDashboard.vue?vue&type=script&lang=js"

import "./FhaMipPaymentsDashboard.vue?vue&type=style&index=0&id=5ac6cbc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac6cbc4"]])

export default __exports__